<template>
    <p-inc-mail-menu-content
        :items         = "steps"
        :selected-item = "selected"
        :item-label    = "$t('mail.attachments.step')"
        item-text      = "name"
        :width         = "500"
        @search        = "onSearch"
        @selected      = "onStep"
    >
        <template v-slot:item="{ item }">
            <div>
                {{ item.name }}
            </div>
        </template>
        <template v-slot:selection="{ item }">
            {{ item.name }}
        </template>

        <template v-slot:content>
            <div class="pa-3 pl-4 pr-1">
                <div class="mt-1">
                    <p-inc-selectable-document
                        v-for     = "(document,index) in filteredDocuments"
                        :key      = "index"
                        :document = "document"
                        class     = "border-style"
                        :class    = "border(index)"
                        :selected = "isSelected(document)"
                        @selected = "onSelected"
                    />

                    <div  v-if="!filteredDocuments || filteredDocuments.length === 0" class="mail-empty-documents error--text">
                        {{ $t('mail.attachments.empty') }}
                    </div>
                </div>
            </div>
        </template>
    </p-inc-mail-menu-content>
</template>

<script>
import PIncMailMenuContent from "@/modules/inc/mail/private/PIncMailMenuContent.vue";
import PIncSelectableDocument from "@/modules/inc/mail/private/PIncSelectableDocument.vue";
import PIncDocumentsMixin from "@/modules/inc/mail/private/PIncDocumentsMixin";
import Inc from "@/modules/inc/service/Inc";
import Core from "@/modules/core/service/Core";

export default {
    name: "PIncAttachments",

    components: {
        PIncSelectableDocument,
        PIncMailMenuContent
    },

    mixins: [
        PIncDocumentsMixin
    ],

    props: {
        incident: {

        },

        step: {

        },

        open: {

        }
    },

    data: () => ({
        selected: null,
        documents: null,
        filteredDocuments: null,
    }),

    computed: {
        steps () {
            if (!this.incident) {
                return [];
            }

            const steps = [];
            this.incident.data.forEach (data => {
                if (data.visible) {
                    steps.push ({
                        id  : data.stepId,
                        name: data.stepName,
                        data: data.id
                    });
                }
            });

            return steps;
        }
    },

    mounted() {
        this.initialize();
    },

    watch: {
        step () {
            this.initialize();
        },

        open () {
            if (this.open && this.selected) {
                this.onStep(this.selected);
            }
        }
    },

    methods: {
        initialize () {
            if (!this.incident) {
                return;
            }

            const data = this.incident.data[this.step];
            this.onStep({
                id  : data.stepId,
                name: data.stepName,
                data: data.id
            });
        },

        onSearch (text) {
            if (!text) {
                this.filteredDocuments = this.documents;
                return;
            }

            this.filteredDocuments = this.documents.filter (d => Core.filter.includes(d.name, text));
        },

        onStep (step) {
            this.selected = step;

            Inc.document.byStep(step.data, {
                unitId: null,
                bidId : null,
            }, data => {
                this.documents = data;
                this.filteredDocuments = this.documents;
            });
        }
    }
}
</script>

<style scoped>

.border-style {
    border-style: solid;
    border-color: lightgray;
    border-width: 1px;
}

.mail-empty-documents {
    padding-left: 16px;
    text-align: center;
    padding-bottom: 12px;
}

</style>
